import { lazy } from "react";
import MainLayout from "layout/MainLayout";
import Loadable from "ui-component/Loadable";
import AuthGuard from "utils/route-guard/AuthGuard";

const TransitionTimeline= Loadable(lazy(() => import('views/pages/transitionTimeline/TransitionTimeline')));

const TransitioningTask=Loadable(lazy(()=>import('views/pages/transitionTimeline/TransitioningTask')))
const Profile=Loadable(lazy(()=>import('views/pages/Profile/Profile')))
const EditProfile=Loadable(lazy(()=>import('views/pages/Profile/EditProfile')))
const ChangePassword =Loadable(lazy(()=>import('views/pages/Profile/ChangePassword')))
const GetInTouch =Loadable(lazy(()=>import('views/pages/Profile/GetInTouch')))
const Resources =Loadable(lazy(()=>import('views/pages/Resources/Resources')));
const CMS =Loadable(lazy(()=>import('views/pages/Resources/cms')));

const MainRoutes = {
    path: "/",
    element: (
        <AuthGuard>
        <MainLayout /> 
        </AuthGuard>     
    ),
    children: [
        {
            path:'/transition-timeline',
            element:<TransitionTimeline/>
        },
        {
            path:"/transitioning-task/:i/:id",
            element:<TransitioningTask/>
        },
      
        {
            path:'/profile',
            element:<Profile/>
        },
        {
            path:'/edit-profile',
            element:<EditProfile/>
        },
        {
            path:'/change-password',
            element:<ChangePassword/>
        },
        {
            path:'/contact',
            element:<GetInTouch/>
        },
        {
            path:'/resources',
            element:<Resources/>
        },
        {
         path:"/cms/:slug",
         element:<CMS/>
        },

    ]
}
    export default MainRoutes